<template>
	<div class="cmpnt-box" style="background:#fff">
			<header class="lmy-search-header search-header">
	      <i class="iconfont icon-yuyin" @click="shData.show=false"></i>

				<div class="search-text" style="margin-left:.2rem" >
					<svg class="icon" aria-hidden="true">
						<use xlink:href="#icon-sousuo"></use>
					</svg>
					<input style="width: 80%;" type="text" placeholder="酒店名称/商圈/关键字" v-model="key"/>
				</div>
	    </header>
	    
	    <div class="lmy-search-list" v-if="key">
	    	<div class="list-item" @click="select(key)" v-if="list.length>0">{{key}}</div>
	      <div class="list-item" v-for="hotel in list" @click="select(hotel)">
	          {{hotel.N||hotel.E}}
	      </div>
	      <div class="infinite-loading-containers" v-if="isLoading">
					<i class="loading-defaults"></i>
				</div>
				<div v-if="list&&list.length<=0">
					<h1 class="lmy-search-text-center">很抱歉，暂无结果</h1>
				</div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'search-hotel',
		props:{
			shData:{
				type:Object,
				default:()=>{
					return{}
				}
			},
			RegionID:{
				type:String,
				default:''
			},
			from:{
				type:Number,
				default:1
			}
		},
		data(){
			return{
				data:{},
				key:'',
				list:'',
				isLoading:false
			}
		},
		watch:{
			shData(val){
				this.data=val;
				this.list='';
			},
			RegionID(){
				this.data.From=this.shData.From;
			},
			key(val){
				this.list='';
				this.getHotels(val);

			},
		},
		methods:{
			getHotels(val){
	        	var that=this;
	        	that.isLoading=true;
	            var param={
		            't':that.from==1?0:1,
		            'q':val,
		            'rid':that.RegionID,
		            'pt':0,
		            'page':1,
		            'pageSize':10
		        };
	            that.getRequest({
	              url:that.Api.autoComplete, 
	              params:param
	            }).then(res => {
	            	that.isLoading=false;
	                if(res&&res.Total>0){
	                  that.list=res.Result;
	                }else{
	                	that.list=[]
	                }
	          	});
			},
			select(hotel){
				

				this.$emit('select',hotel.N||hotel.E||hotel);

			}

		},
		mounted(){
			this.data=this.shData;
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/searchHotel.vue